export type PiiType =
  | 'email'
  | 'phone'
  | 'ssn'
  | 'ein' // US Employer Identification Number (XX-XXXXXXX)
  | 'credit_card'
  | 'iban'
  | 'us_zip'
  | 'ipv4'
  | 'ipv6'
  | 'api_key'
  | 'date'
  // reserved for later phases (NER + structured)
  | 'name'
  | 'address'
  | 'dob'
  | 'drivers_license'
  | 'passport'
  | 'vin' // Vehicle identification number
  | 'license_plate'
  | 'routing_number' // ABA bank routing number
  | 'bank_account'
  // International identifiers (Phase 4).
  | 'uk_postcode'
  | 'sin' // Canadian Social Insurance Number
  | 'aadhaar' // Indian Aadhaar
  | 'cpf' // Brazilian CPF
  | 'cnpj'; // Brazilian CNPJ

export type TextDetection = {
  type: PiiType;
  text: string;
  start: number;
  end: number;
  confidence: number;
  source?: 'regex' | 'ner' | 'form';
};

export type BBox = { x: number; y: number; w: number; h: number };

/**
 * A PII hit lifted out of OCR'd text. Each hit carries one or more
 * normalized [0..1] rects (one per visual word covered by the
 * detection) so the same value renders correctly at preview scale and
 * output scale, identical to manual rects.
 */
export type ImageTextHit = {
  type: PiiType;
  text: string;
  /** Normalized rects in [0..1] of the source bitmap / page canvas. */
  rects: { x: number; y: number; w: number; h: number }[];
  confidence: number;
  source: 'ocr';
};

/** Human-readable label for a PII type, used in the review UI. */
export const PII_LABEL: Record<PiiType, string> = {
  email: 'email',
  phone: 'phone',
  ssn: 'ssn',
  ein: 'EIN',
  credit_card: 'credit card',
  iban: 'bank account',
  us_zip: 'us zip',
  ipv4: 'ip address',
  ipv6: 'ip address',
  api_key: 'api key',
  date: 'date',
  name: 'name',
  address: 'address',
  dob: 'date of birth',
  drivers_license: "driver's license",
  passport: 'passport',
  vin: 'VIN',
  license_plate: 'license plate',
  routing_number: 'routing number',
  bank_account: 'bank account',
  uk_postcode: 'UK postcode',
  sin: 'Canadian SIN',
  aadhaar: 'Aadhaar number',
  cpf: 'Brazilian CPF',
  cnpj: 'Brazilian CNPJ',
};
